import useLenis from "../hooks/useLenis";
import Navigation from "../components/site/Navigation";
import Hero from "../components/site/Hero";
import TrustedBy from "../components/site/TrustedBy";
import ChannelShowcase from "../components/site/ChannelShowcase";
import FeaturedVideos from "../components/site/FeaturedVideos";
import StatsBento from "../components/site/StatsBento";
import AboutCreator from "../components/site/AboutCreator";
import BrandMarquee from "../components/site/BrandMarquee";
import WhyBrands from "../components/site/WhyBrands";
import EventCoverage from "../components/site/EventCoverage";
import Services from "../components/site/Services";
import SocialProof from "../components/site/SocialProof";
import ContactForm from "../components/site/ContactForm";
import Footer from "../components/site/Footer";

export default function HomePage() {
  useLenis();

  return (
    <main data-testid="home-page" className="min-h-screen bg-[var(--tt-bg)] text-[var(--tt-text)]">
      <Navigation />
      <Hero />
      <TrustedBy />
      <ChannelShowcase />
      <FeaturedVideos />
      <StatsBento />
      <AboutCreator />
      <BrandMarquee />
      <WhyBrands />
      <EventCoverage />
      <Services />
      <SocialProof />
      <ContactForm />
      <Footer />
    </main>
  );
}
